import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../../Slices/Mof/Styles.json";
import MaritalStatusOtherInfo from "./MaritalStatusOtherInfo";

import axios from 'axios'
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import Cookies from "universal-cookie";
import swal from "sweetalert";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

function MaritalStatus({getCurrentReportDataAfterUpdate,object,Access,advanceSearch,section_id,stage_transaction_type_id}) {
    const [maritalStatus,setMaritalStatus]=useState(object?.marital_status)
    const [numberOfWives,setNumberOfWives]=useState(object?.number_of_wives)
    const [wifeOrHusbandName,setWifeOrHusbandName]=useState(object?.wife_or_husband_name)
    const [wifeOrHusbandCarrier,setWifeOrHusbandCarrier]=useState(object?.wife_or_husband_career)
    const [wifeOrHusbandFolderNumber,setWifeOrHusbandFolderNumber]=useState(object?.wife_or_husband_folder_number)
    const [wifeOrHusbandBranch,setWifeOrHusbandBranch]=useState(object?.wife_or_husband_branch)


    const [loading,setLoading]=useState(false)
    const updateData=async()=>{
        let data=null;
        setLoading(true);
        try{
            data=await axios({
               method: 'put',
               url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
               data:{
                section_name:'6',
                marital_status:maritalStatus,
                number_of_wives:numberOfWives,
                wife_or_husband_name:wifeOrHusbandName,
                wife_or_husband_career:wifeOrHusbandCarrier,
                wife_or_husband_folder_number:wifeOrHusbandFolderNumber,
                wife_or_husband_branch:wifeOrHusbandBranch,
                user_id:cookies.get('user_id'),
                role_id:cookies.get('role_id')+1,
                section_id:section_id,
                stage_transaction_type_id:stage_transaction_type_id
               },
               headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-localization": language,
               }
            })
            if(data){
                if(data?.data?.status==200){
                    swal("تم التحديث!", `${data?.data?.message}`, "success");
                    setMaritalStatus(data?.data?.data?.marital_status);
                    setNumberOfWives(data?.data?.data?.number_of_wives);
                    setWifeOrHusbandName(data?.data?.data?.wife_or_husband_name);
                    setWifeOrHusbandCarrier(data?.data?.data?.wife_or_husband_career);
                    setWifeOrHusbandFolderNumber(data?.data?.data?.wife_or_husband_folder_number);
                    setWifeOrHusbandBranch(data?.data?.data?.wife_or_husband_branch);
                    advanceSearch()
                    getCurrentReportDataAfterUpdate()

                }else{
                    console.log(data?.data?.message);
                    swal("فشل التحديث!", `${data?.data?.message}`, "warning");

                }
            }
        setLoading(false);

        }catch(err){
            swal("فشل التحديث!", `${err?.message}`, "error");
            setLoading(false);

        }
        
    }
    const checkAccessPrivilegesCanEdit=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==3){
                check=true;
             }
        })
        return check;
    }
    const checkAccessPrivilegesCanAdd=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==2){
                check=true;
             }
        })
        return check;
    }
    const checkAccessPrivileges =()=>{
        let check=true;
        Access?.map((data)=>{
            if(data==1){
                check=true;
            }else if(data==2||data==3||data==4){
                check=false
            }
        })
        return check;
    }

    return (
        <>
            {/*###==> marital status here ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                الحالة الاجتماعية{" "}
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingLeft: 10,
                        paddingTop: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="career-simple-select-label">
                            الحالة الاجتماعية
                        </InputLabel>
                        <Select
                            labelId="career-simple-select-label"
                            disabled={checkAccessPrivileges()}
                            id="career-simple-select"
                            value={maritalStatus}
                            label="الحالة الاجتماعية "
                            onChange={(e) => {
                               setMaritalStatus(e.target.value)
                               if(e.target.value=='متزوج'){
                                   setNumberOfWives(1)
                               }else{
                                setNumberOfWives(0)
                               }
                            }}
                        >
                            <MenuItem value={"اعزب"}>{"اعزب"}</MenuItem>
                            <MenuItem value={"متزوج"}>{"متزوج"}</MenuItem>
                            <MenuItem value={"مطلق"}>{"مطلق"}</MenuItem>
                            <MenuItem value={"ارمل"}>{"ارمل"}</MenuItem>
                        </Select>
                    </FormControl>

                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.maritalStatus) {
                            return err.maritalStatus;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="عدد الزوجات"
                            variant="outlined"
                            type={"number"}
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            value={numberOfWives}
                            onChange={(e) => {
                                setNumberOfWives(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.numberOfWives) {
                            return err.numberOfWives;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>
            </div>
            <MaritalStatusOtherInfo 
              object={object} 
              wifeOrHusbandName={wifeOrHusbandName}
              setWifeOrHusbandName={setWifeOrHusbandName}
              wifeOrHusbandCarrier={wifeOrHusbandCarrier}
              setWifeOrHusbandCarrier={setWifeOrHusbandCarrier}
              wifeOrHusbandBranch={wifeOrHusbandBranch}
              setWifeOrHusbandBranch={setWifeOrHusbandBranch}
              wifeOrHusbandFolderNumber={wifeOrHusbandFolderNumber}
              setWifeOrHusbandFolderNumber={setWifeOrHusbandFolderNumber}
              checkAccessPrivileges={checkAccessPrivileges}
            />

            {
                checkAccessPrivilegesCanAdd()||checkAccessPrivilegesCanEdit()?
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <Button variant="contained" style={{backgroundColor:"#5f7b8a",paddingLeft:30,paddingRight:30}}
                    onClick={()=>{
                        updateData();
                    }}
                    >
                        {!loading ? (
                        "تحديث"
                    ) : (
                        <div class="spinner-border " role="status">
                        <span class="visually-hidden">Loading...</span>
                        </div>
                    )}
                    </Button>
                </div>:null
            }
        </>
    )
}

export default MaritalStatus